import React from 'react';
import {useDocumentContext} from 'react-pdf';

import {isDestroyedPdfDocument} from './PdfViewer.utils';

/**
 * Renders its children only while the document react-pdf loaded is still usable.
 *
 * react-pdf publishes the result of a load it has already abandoned (see
 * isDestroyedPdfDocument), and <Page> calls getPage() on the document straight
 * inside an effect. On a destroyed document that call throws instead of
 * rejecting, and a throw in an effect escapes as a render error — taking down
 * the whole route instead of just the preview. Skipping the page for the short
 * moment such a document is on display keeps the failure out of the tree; the
 * load that replaced it renders the page again.
 */
export function PdfDocumentGuard({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement | null {
  const pdf = useDocumentContext()?.pdf;

  if (!pdf || isDestroyedPdfDocument(pdf)) {
    return null;
  }

  return <>{children}</>;
}
